<template>
  <div class="device-item-content" ref="table">
    <div class="device-table">
      <u-table :data="devices" use-virtual showBodyOverflow="title" showHeaderOverflow="title" :height="tabHeight" stripe>
        <u-table-column type="index" width="60" label="序号" sortable fit align="center"></u-table-column>
        <u-table-column prop="name" label="名称" sortable fit align="center">
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </u-table-column>
        <u-table-column prop="alarm" label="状态" sortable fit align="center">
          <template slot-scope="scope">
            {{scope.row.alarm?"报警":"正常"}}
          </template>
        </u-table-column>
        <u-table-column prop="poleName" label="所在灯杆" sortable fit align="center">
          <template slot-scope="scope">
            {{scope.row.poleName}}
          </template>
        </u-table-column>
        <u-table-column prop="acv" label="交流电压" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{scope.row.acv || 0}}
          </template>
        </u-table-column>
        <u-table-column prop="aci" label="交流电流" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{scope.row.aci || 0}}
          </template>
        </u-table-column>
        <u-table-column prop="acp" label="交流功率" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{scope.row.acp || 0}}
          </template>
        </u-table-column>

        <u-table-column prop="poe" label="是否启用POE" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{isPoeWork(scope.row.poe)}}
          </template>
        </u-table-column>
        <u-table-column label="1号槽" align="center">
          <u-table-column prop="k1" label="继电器输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.k1?"关":"开"}}
            </template>
          </u-table-column>
          <u-table-column prop="s1" label="开入量输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.s1?"关":"开"}}
            </template>
          </u-table-column>
          <u-table-column prop="p1s" label="工作状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isGrooveWork(scope.row.p1s)}}
            </template>
          </u-table-column>
          <u-table-column prop="p1m" label="主电源类型" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.p1m)}}
            </template>
          </u-table-column>
          <u-table-column prop="dc1m" label="主电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc1m)}}
            </template>
          </u-table-column>
          <u-table-column prop="dc1s" label="从电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc1s)}}
            </template>
          </u-table-column>
        </u-table-column>
        <u-table-column label="2号槽" align="center">
          <u-table-column prop="k2" label="继电器输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.k2?"关":"开"}}
            </template>
          </u-table-column>

          <u-table-column prop="s2" label="开入量输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.s2?"关":"开"}}
            </template>
          </u-table-column>
          <u-table-column prop="p2s" label="工作状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isGrooveWork(scope.row.p2s)}}
            </template>
          </u-table-column>
          <u-table-column prop="p2m" label="主电源类型" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.p2m)}}
            </template>
          </u-table-column>

          <u-table-column prop="dc2m" label="主电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc2m)}}
            </template>
          </u-table-column>
          <u-table-column prop="dc2s" label="从电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc2s)}}
            </template>
          </u-table-column>
        </u-table-column>
        <u-table-column label="3号槽" align="center">
          <u-table-column prop="k3" label="继电器输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.k3?"关":"开"}}
            </template>
          </u-table-column>
          <u-table-column prop="s3" label="开入量输出状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{scope.row.s3?"关":"开"}}
            </template>
          </u-table-column>
          <u-table-column prop="p3s" label="工作状态" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isGrooveWork(scope.row.p3s)}}
            </template>
          </u-table-column>
          <u-table-column prop="p3m" label="主电源类型" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.p3m)}}
            </template>
          </u-table-column>
          <u-table-column prop="dc3m" label="主电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc3m)}}
            </template>
          </u-table-column>
          <u-table-column prop="dc3s" label="从电源电压" sortable fit align="center" width="155">
            <template slot-scope="scope">
              {{isPowerType(scope.row.dc3s)}}
            </template>
          </u-table-column>
        </u-table-column>
        <u-table-column prop="pv" label="POE输出电压" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{isPowerType(scope.row.pv)}}
          </template>
        </u-table-column>
        <u-table-column prop="temp" label="工作温度" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{isPowerType(scope.row.temp)}}
          </template>
        </u-table-column>
        <u-table-column prop="time" label="发生时间" sortable fit align="center" width="155">
          <template slot-scope="scope">
            {{isPowerType(scope.row.time)}}
          </template>
        </u-table-column>

        <u-table-column width="220" label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="cameraInfo-tab-but color1" @click="history(scope.row)"><img :src="img.pole.speak.record" />查看详情</a>
          </template>
        </u-table-column>
      </u-table>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'deviceList2',
  components: {
  },
  props: {
    devices: {
      type: Array,
      default(){return []},
    },
  },
  data() {
    return {
      tabData: [],
      tabHeight: 600,
    }
  },
  computed: {
    ...mapState('group', ['selectedNode', 'selectedDevices']),
    ...mapGetters('group', ['groupPathName']),
    ...mapState('common', ['productCodes', 'powerBoxTypes', 'mapCenter']),
  },
  watch: {},
  mounted: function () {
  },
  methods: {
    isPoeWork(key) {
      let name = "不启用";
      switch (key) {
        case 0:
          name = "不启用";
          break;
        case 1:
          name = "2号槽供电";
          break;
        case 2:
          name = "3号槽供电";
          break;
      }
      return name;
    },
    isGrooveWork(key) {
      let name = "独立工作";
      switch (key) {
        case 0:
          name = "独立工作";
          break;
        case 1:
          name = "主电源工作";
          break;
        case 2:
          name = "从电源工作";
          break;
      }
      return name;
    },
    isPowerType(key) {
      let name = "空或坏";
      switch (key) {
        case 0:
          name = "空或坏";
          break;
        case 1:
          name = "5V";
          break;
        case 2:
          name = "12V";
          break;
        case 3:
          name = "24V";
          break;
        case 4:
          name = "48V";
          break;
        case 5:
          name = "POE";
          break;
        case 6:
          name = "未初始化";
          break;
      }
      return name;
    },
    history(params) {
      // console.log('select node ', params.poleId)
      this.$store.commit('group/selectPoleTreeNode', { id: params.poleId, isLeaf: true });
      // this.$store.commit('auth/switchStationTabName', 'power');
    },
    setTableHeight: function () {
      this.tabHeight = this.$refs.table.clientHeight - 100;
    },

  }
}
</script>
<style scoped>
.device-item-content {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px 30px;
}
.tool-type {
  width: 168px;
  height: 32px;
  margin: 0 10px 0 5px;
}
.cameraInfo-search-but {
  padding: 3px 12px;
  display: inline-block;
  background: #007eff;
  border-radius: 4px;
  vertical-align: middle;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 32px;
  margin-left: 19px;
}
.cameraInfo-search-but img {
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 2px;
}
.cameraInfo-tab-but {
  padding: 0px 12px;
  display: inline-block;
  background: #007eff;
  border-radius: 4px;
  vertical-align: middle;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  margin: 0 5px;
}
.cameraInfo-tab-but img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 3px;
}

.cameraInfo-tab-but.color1 {
  background: #21a4f8;
}
.cameraInfo-tab-but.color2 {
  background: #3cbf6e;
}
.cameraInfo-tab-but.color3 {
  background: #fd5353;
}
.cameraInfo-tab-but.color4 {
  background: #6485fd;
}
.device-table {
  margin-top: 20px;
}
.device-table /deep/ .plTableBox .el-table th {
  padding: 5px 0;
  background: #eaf1f9;
}
.device-table /deep/ .plTableBox .el-table td {
  padding: 5px 0;
}
</style>
